import {linkResolver} from '@navbar-unlogged/helpers';
import type {KeyTextField, LinkField} from '@prismicio/types';
import type {Location} from '@malt/nuxt-common-components-module/types';
import {getSearchURL, getQueryAutocomplete} from '@malt/nuxt-search-module/runtime/composables/useSearchHelpers';
import {useTypeGuards} from './useTypeGuards';

type GetSearchURLParams = {
    baseURLLink: LinkField | KeyTextField;
    query: string;
    location: Location | null;
    sourceComponent?: string; // to track the search_started Amplitude event
};

const {isFilledKeyText, isFilledLink} = useTypeGuards();

function getSearchUrlFromPrismicLink({baseURLLink, query, location, sourceComponent}: GetSearchURLParams): string {
    if (baseURLLink === null || (!isFilledKeyText(baseURLLink) && !isFilledLink(baseURLLink))) {
        return window.location.href;
    }
    const baseURL = isFilledKeyText(baseURLLink) ? baseURLLink : baseURLLink.link_type === 'Document' ? linkResolver(baseURLLink) : baseURLLink.url;

    return getSearchURL({
        baseURLLink: baseURL,
        query,
        location,
        sourceComponent,
    });
}

function createNavbarSearchHelpers() {
    return {
        getSearchURL: getSearchUrlFromPrismicLink,
        getQueryAutocomplete,
    };
}

export {createNavbarSearchHelpers as useSearchHelpers};
